<template lang="pug">
  .camp-page
    .camp-page__body
      section.camp-page__section
        .camp-page__mobile-gallery(
          v-if="windowWidth < 1201"
        )
          .mobile-gallery
            image-slider(
            :data-images="images"
            )
        .container
          .camp
            .camp__side
              .gallery(
                v-if="windowWidth > 1200"
              )
                .photo(
                  v-for="image in campData.gallery"
                  @click="onClickPhoto()"
                )
                  img(:src="image.file")
            .camp__main
              .camp__header
                camp-header(
                  :camp-address="campData.address"
                  :title="campData.name"
                  :campType="getCampType()"
                  :tags="campData.tags"
                  :rating="campData.rating"
                )
              .camp__content.camp-content
                .camp-content__header
                  .camp-tabs
                    .camp-tabs__container
                      .camp-tabs__item(
                        v-for="(tab, tabKey) in tabs"
                      )
                        .camp-tab-button(
                          v-bind:class="[{ 'camp-tab-button_active': currentTab === tabKey }]"
                          v-on:click="switchTab(tabKey)"
                        ) {{ tab }}
                .camp-content__body
                  camp-about(
                  v-if="currentTab === 'description'"
                  :description="campData.description"
                  )
                  camp-placement(
                  v-if="currentTab === 'placement'"
                  :placement="campData.placement"
                  )
                  camp-docs(
                  v-if="currentTab === 'required_documents'"
                  :docs="campData.required_documents"
                  )
                  camp-things(
                  v-if="currentTab === 'necessary_equipment'"
                  :things="campData.necessary_equipment"
                  )
                  camp-contacts(
                  v-if="currentTab === 'contacts'"
                  :camp-data="campData"
                  )
      //section.camp-page__section.section(
      //v-if="shiftsData.length > 0"
      //)
      //  .container
      //    .section__title
      //      h2.section-title Все смены лагеря
      //    .section__body
      //      shifts-slider(
      //      :slider-data="shiftsData"
      //      :slides-count="campsSliderCount"
      //      )
      section.camp-page__section.section(
        v-if="windowWidth > 720"
      )
        .camp-map(
          v-if="campData.geo_lat && campData.geo_lon"
        )
          l-map(
            ref='mainMap'
            id='mainMap'
            :zoom='zoom'
            :center='[campData.geo_lat, campData.geo_lon]'
            :options='mapOptions'
          )
            l-tile-layer(
              :url='url'
            )
            l-marker(
              :lat-lng='[campData.geo_lat, campData.geo_lon]'
              :icon="generateIcon()"
            )

      section.camp-page__section.section(
        v-if="windowWidth > 720"
      )
        .container
          .section__title
            h2.section-title Другие лагеря
          .section__body
            camps-slider(
            :slider-data="camps"
            )
      .camp-page__footer
        main-footer

    photo-gallery(
      :photos="campData.photos"
      v-show="showPhotoGallery"
      @onHidePhotoGallery="onHidePhotoGallery"
    )
</template>

<script>
import {mapActions, mapState} from "vuex";
import L from "leaflet";
import {LMap, LTileLayer, LMarker} from "vue2-leaflet";

import CampHeader from "./components/CampHeader.vue";
import OtherCamps from "./components/OtherCamps.vue";
import MainFooter from "@/components/footer/Footer.vue";

import PhotoGallery from "@/components/photoGallery/PhotoGallery.vue";
import ImageSlider from "@/components/imageSlider/ImageSlider";
import CampPlacement from "./components/CampPlacement";
import CampDocs from "./components/CampDocs";
import CampThings from "./components/CampThings";
import CampContacts from "./components/CampContacts";
import CampAbout from "./components/CampAbout";
import CampsSlider from "../../../../components/camps-slider/CampsSlider";
import ShiftsSlider from "../../../../components/shifts-slider/ShiftsSlider.vue";

export default {
  name: "CurrentCamp",
  components: {
    ShiftsSlider,
    CampsSlider,
    CampAbout,
    CampContacts,
    CampThings,
    CampDocs,
    CampPlacement,
    ImageSlider,
    CampHeader,
    OtherCamps,
    MainFooter,
    LMap,
    LTileLayer,
    LMarker,
    PhotoGallery
  },
  data() {
    return {
      zoom: 11,
      center: L.latLng(55.315919, 50.985943),
      url: "https://a.tile.openstreetmap.de/{z}/{x}/{y}.png",
      // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      mapOptions: {
        attributionControl: false,
        scrollWheelZoom: false
      },
      campData: {
        address: {},
        tags: {},
        photos: []
      },
      shiftsData: [],
      currentTab: "description",
      currentTabContent: "",
      tabs: {
        description: "О лагере",
        placement: "Размещение",
        required_documents: "Документы",
        necessary_equipment: "Памятка родителям",
        contacts: "Контакты"
      },
      showPhotoGallery: false,
      images: [],
      windowWidth: window.innerWidth,
      campsSliderCount: 4,
      camps: []
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    campId() {
      return this.$route.params.campId;
    }
  },
  methods: {
    ...mapActions(["getCamp", "getCamps", "getShifts"]),
    generateIcon() {
      return L.icon({
        iconUrl: require("../../../../assets/images/map/marker.svg"),
        iconSize: [40, 40],
        iconAnchor: [20, 20]
      });
    },
    switchTab(tab) {
      this.currentTab = tab;
    },
    onClickPhoto() {
      this.showPhotoGallery = true;
      document.body.style.overflow = "hidden";
    },
    onHidePhotoGallery() {
      this.showPhotoGallery = false;
      document.body.style.overflow = "inherit";
    },
    buildCurrentCamp() {
      this.$root.$emit("on-show-preloader");
      this.getCamp(this.campId).then(campRes => {
        this.campData = campRes;
        // this.campData.gallery = campRes.photos.slice(0, 6);
        this.campData.gallery = campRes.photos;
        this.shiftsData = campRes.campshifts;
        //        this.shiftsData.length = 3;
        this.$root.$emit("on-hide-preloader");
      });
    },
    getCampType() {
      for (var i = 0; i < this.catalogue.campTypes.length; i++) {
        if (this.catalogue.campTypes[i].value === this.campData.type) {
          return this.catalogue.campTypes[i].text;
        }
      }
    },
    calcSlidesCount() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 1340) {
        this.campsSliderCount = 4;
      } else if (this.windowWidth < 1341 && this.windowWidth > 720) {
        this.campsSliderCount = 3;
      } else {
        this.campsSliderCount = 1;
      }
    }
  },
  mounted() {
    this.buildCurrentCamp();
    this.calcSlidesCount();
    this.getCamps({
      params: {
        limit: 8,
        random: true
      }
    }).then(res => {
      this.camps = res.results;
    });

    window.onresize = () => {
      this.calcSlidesCount();
    };
  },
  watch: {
    "$route.params.campId"() {
      this.buildCurrentCamp();
    },
    campData() {
      for (var i = 0; i < this.campData.gallery.length; i++) {
        this.images.push(this.campData.gallery[i].file);
      }
    }
  }
};
</script>
